import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "trails"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_ButtonAccordion = _resolveComponent("ButtonAccordion")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_QuizTrigger = _resolveComponent("QuizTrigger")!

  return (_ctx.storeTrail.trails?.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.storeLoader.load[2])
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              loader: _ctx.storeLoader.load[2],
              loaderSize: "h-28",
              spinnerSize: "small"
            }, null, 8, ["loader"]))
          : (_openBlock(), _createBlock(_component_Accordion, {
              key: 1,
              id: "trail",
              activeIndex: _ctx.storeTrail.currentTrailIndex,
              onTabOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeTrail.selectTrail($event.index))),
              expandIcon: "",
              collapseIcon: "",
              class: "custom-into",
              lazy: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeTrail.trails, (trail, trailIndex) => {
                  return (_openBlock(), _createBlock(_component_AccordionTab, {
                    key: trail.id
                  }, {
                    header: _withCtx(() => [
                      _createVNode(_component_ButtonAccordion, {
                        data: trail,
                        index: trailIndex,
                        isTrail: ""
                      }, null, 8, ["data", "index"])
                    ]),
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 3
            }, 8, ["activeIndex"])),
        _createVNode(_component_QuizTrigger)
      ]))
    : _createCommentVNode("", true)
}